import type { AriaAttributes } from 'react'

/** Whether an `aria-invalid` value is one that `[aria-invalid=true]` matches. */
export const isAriaInvalid = (value: AriaAttributes['aria-invalid']) =>
  value === true || value === 'true'
